import useMyWorkspacesChildren from '../../workspace/hooks/useMyWorkspacesChildren';
import { useMemo } from 'react';
import useMultipleQueries from '../../../shared/util/rtk/useQueries';
import StructureAPI from '../StructureAPI';
import { FlexeserveGroupStructure } from '../GroupsAdapter';
import { UseQuerySubscription } from '@reduxjs/toolkit/dist/query/react/buildHooks';

type Data = FlexeserveGroupStructure & {
  businessUnits: string[];
  regions: string[];
  districts: string[];
  stores: string[];
  commanderIds: string[];
};
type Options = Parameters<UseQuerySubscription<any>>[1];

function useStructuresWorkspaces(options?: Options) {
  const { data } = useMyWorkspacesChildren(options);
  const keysWorkspaces = useMemo(() => Object.keys(data || {}), [data]);

  const structures = useMultipleQueries<Data, string>(
    StructureAPI.endpoints.getStructureV2,
    keysWorkspaces,
    {
      ...options,
      skip: !keysWorkspaces?.length || options?.skip,
    }
  );

  return structures;
}

export default useStructuresWorkspaces;
